var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 713,
    height: 400,
    viewBox: "0 0 713 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 453.22,
    y: -73.8882,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 453.22 -73.8882)",
    fill: "#134AE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 443.29,
    y: -56.6895,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 443.29 -56.6895)",
    fill: "#51ABB0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 433.36,
    y: -39.4907,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 433.36 -39.4907)",
    fill: "#134AE5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 423.43,
    y: -22.292,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 423.43 -22.292)",
    fill: "#FE8145"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 413.5,
    y: -5.09277,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 413.5 -5.09277)",
    fill: "#ADE2E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 403.57,
    y: 12.106,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 403.57 12.106)",
    fill: "#134AE5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 377.091,
    y: 57.9697,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 377.091 57.9697)",
    fill: "#51ABB0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 367.161,
    y: 75.1685,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 367.161 75.1685)",
    fill: "#6024D2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 357.231,
    y: 92.3672,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 357.231 92.3672)",
    fill: "#51ABB0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 347.302,
    y: 109.566,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 347.302 109.566)",
    fill: "#FE8145"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 337.372,
    y: 126.765,
    width: 138.975,
    height: 13.2397,
    rx: 6.61987,
    transform: "rotate(30 337.372 126.765)",
    fill: "#00CAF1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 327.442,
    y: 143.964,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 327.442 143.964)",
    fill: "#51ABB0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 259.244,
    y: -73.769,
    width: 138.975,
    height: 13.2397,
    rx: 6.61986,
    transform: "rotate(30 259.244 -73.769)",
    fill: "#ADE2E1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 317.513,
    y: 161.163,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 317.513 161.163)",
    fill: "#51ABB0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 249.314,
    y: -56.5703,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 249.314 -56.5703)",
    fill: "#00CAF1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 271.174,
    y: 241.424,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 271.174 241.424)",
    fill: "#51ABB0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 202.976,
    y: 23.6914,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 202.976 23.6914)",
    fill: "#00CAF1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 307.583,
    y: 178.362,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 307.583 178.362)",
    fill: "#ADE2E1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 239.385,
    y: -39.3711,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 239.385 -39.3711)",
    fill: "#FE8145"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 281.104,
    y: 224.225,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 281.104 224.225)",
    fill: "#134AE5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 212.905,
    y: 6.49219,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 212.905 6.49219)",
    fill: "#FE8145"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 251.314,
    y: 275.822,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 251.314 275.822)",
    fill: "#FE8145"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 183.116,
    y: 58.0889,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 183.116 58.0889)",
    fill: "#FE8145"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 261.244,
    y: 258.623,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 261.244 258.623)",
    fill: "#ADE2E1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 193.046,
    y: 40.8901,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 193.046 40.8901)",
    fill: "#FE4545"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 241.385,
    y: 293.021,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 241.385 293.021)",
    fill: "#DCDCDC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 173.187,
    y: 75.2876,
    width: 138.975,
    height: 13.2397,
    rx: 6.61987,
    transform: "rotate(30 173.187 75.2876)",
    fill: "#FFE600"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 214.905,
    y: 338.884,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 214.905 338.884)",
    fill: "#134AE5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 146.707,
    y: 121.151,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 146.707 121.151)",
    fill: "#6024D2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 204.976,
    y: 356.083,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 204.976 356.083)",
    fill: "#51ABB0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 136.777,
    y: 138.35,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 136.777 138.35)",
    fill: "#A87AFF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 195.046,
    y: 373.282,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 195.046 373.282)",
    fill: "#00CAF1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 126.848,
    y: 155.549,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 126.848 155.549)",
    fill: "#00CAF1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 185.116,
    y: 390.481,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 185.116 390.481)",
    fill: "#134AE5"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 116.918,
    y: 172.748,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 116.918 172.748)",
    fill: "#51ABB0"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4385,
    y: 218.612,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 90.4385 218.612)",
    fill: "#ADE2E1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 80.5088,
    y: 235.811,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 80.5088 235.811)",
    fill: "#134AE5"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5781,
    y: 253.009,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 70.5781 253.009)",
    fill: "#5AFFA7"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 60.6484,
    y: 270.208,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 60.6484 270.208)",
    fill: "#6024D2"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7188,
    y: 287.407,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 50.7188 287.407)",
    fill: "#00CAF1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 40.7891,
    y: 304.606,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 40.7891 304.606)",
    fill: "#FF5300"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8594,
    y: 321.805,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 30.8594 321.805)",
    fill: "#0085FF"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 713.087,
    y: 124.558,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 713.087 124.558)",
    fill: "#51ABB0"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 703.157,
    y: 141.756,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 703.157 141.756)",
    fill: "#134AE5"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 693.227,
    y: 158.955,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 693.227 158.955)",
    fill: "#FE8145"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 683.297,
    y: 176.154,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 683.297 176.154)",
    fill: "#ADE2E1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 673.367,
    y: 193.353,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 673.367 193.353)",
    fill: "#ADE2E1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 663.438,
    y: 210.552,
    width: 138.975,
    height: 13.2397,
    rx: 6.61983,
    transform: "rotate(30 663.438 210.552)",
    fill: "#134AE5"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 653.508,
    y: 227.75,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 653.508 227.75)",
    fill: "#00CAF1"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 627.028,
    y: 273.614,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 627.028 273.614)",
    fill: "#6024D2"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 617.099,
    y: 290.813,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 617.099 290.813)",
    fill: "#FE8145"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 607.169,
    y: 308.012,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 607.169 308.012)",
    fill: "#00CAF1"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 597.239,
    y: 325.211,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 597.239 325.211)",
    fill: "#51ABB0"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 570.76,
    y: 371.075,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 570.76 371.075)",
    fill: "#51ABB0"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 560.83,
    y: 388.273,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 560.83 388.273)",
    fill: "#51ABB0"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 639.974,
    y: -73.0811,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 639.974 -73.0811)",
    fill: "#FE8145"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 616.804,
    y: -32.9502,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 616.804 -32.9502)",
    fill: "#ADE2E1"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 606.874,
    y: -15.7515,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 606.874 -15.7515)",
    fill: "#FE8145"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 596.944,
    y: 1.44727,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 596.944 1.44727)",
    fill: "#134AE5"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 587.015,
    y: 18.646,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 587.015 18.646)",
    fill: "#134AE5"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 577.085,
    y: 35.8452,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 577.085 35.8452)",
    fill: "#134AE5"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 567.155,
    y: 53.0439,
    width: 138.975,
    height: 13.2397,
    rx: 6.61986,
    transform: "rotate(30 567.155 53.0439)",
    fill: "#134AE5"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 557.226,
    y: 70.2427,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 557.226 70.2427)",
    fill: "#51ABB0"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 547.296,
    y: 87.4414,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 547.296 87.4414)",
    fill: "#ADE2E1"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 524.126,
    y: 127.572,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 524.126 127.572)",
    fill: "#ADE2E1"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 514.196,
    y: 144.771,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 514.196 144.771)",
    fill: "#134AE5"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 504.267,
    y: 161.97,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 504.267 161.97)",
    fill: "#6024D2"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 494.337,
    y: 179.169,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 494.337 179.169)",
    fill: "#00CAF1"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 484.407,
    y: 196.368,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 484.407 196.368)",
    fill: "#6024D2"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 474.478,
    y: 213.566,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 474.478 213.566)",
    fill: "#6024D2"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 464.548,
    y: 230.766,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 464.548 230.766)",
    fill: "#ADE2E1"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 441.378,
    y: 270.896,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 441.378 270.896)",
    fill: "#ADE2E1"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 431.448,
    y: 288.095,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 431.448 288.095)",
    fill: "#00CAF1"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 421.519,
    y: 305.294,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 421.519 305.294)",
    fill: "#51ABB0"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 411.589,
    y: 322.493,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 411.589 322.493)",
    fill: "#F5FF00"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 401.659,
    y: 339.691,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 401.659 339.691)",
    fill: "#51ABB0"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 378.489,
    y: 379.822,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 378.489 379.822)",
    fill: "#134AE5"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 368.56,
    y: 397.021,
    width: 138.975,
    height: 13.2397,
    rx: 6.61984,
    transform: "rotate(30 368.56 397.021)",
    fill: "#00CAF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlock);
export default __webpack_public_path__ + "static/media/bg_block.444ff02fc00f9d4f48d44fcd95f3213d.svg";
export { ForwardRef as ReactComponent };